import * as React from "react";
import * as ReactDOM from "react-dom";
import { Modal } from "antd";

interface IModalEnhanceProps {
  title: string;
  visible: boolean;
  childComponent: any;
  close: any;
  ok: any;
}

// 弹窗增强
class ModalEnhance extends React.Component<IModalEnhanceProps, any> {
  constructor(props: IModalEnhanceProps) {
    super(props);
  }

  static newInstance = function newModalEnhance(properties: any, callback) {
    const { ...props } = properties || {};
    const div = document.createElement("div");
    document.body.appendChild(div);
    let called = false;
    function ref(drawerTransfer) {
      if (called) {
        return;
      }
      called = true;
      callback({
        component: drawerTransfer,
        destroy: () => {
          setTimeout(() => {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentNode) div.parentNode.removeChild(div);
          }, 200);
        }
      });
    }
    ReactDOM.render(<ModalEnhance {...props} ref={ref} />, div);
  };

  render() {
    return (
      <Modal
        title={this.props.title}
        width={660}
        maskClosable={false}
        centered
        //	关闭时销毁 Modal 里的子元素
        destroyOnClose
        visible={this.props.visible}
        onOk={this.props.ok}
        onCancel={this.props.close}
      >
        {this.props.childComponent}
      </Modal>
    );
  }
}

export default ModalEnhance;
